import { render, staticRenderFns } from "./recycling.vue?vue&type=template&id=4bf34b2a&scoped=true"
import script from "./recycling.vue?vue&type=script&lang=js"
export * from "./recycling.vue?vue&type=script&lang=js"
import style0 from "./recycling.vue?vue&type=style&index=0&id=4bf34b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf34b2a",
  null
  
)

export default component.exports